<template>
  <div class="private-cloud-resource-detail-content">
    <VolumeEdit ref="VolumeEdit" v-on:editComplete="init"></VolumeEdit>
    <Card shadow style="border-radius: unset">
      <a style="margin-right: 24px" v-on:click="$router.push({ name: 'volumes' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      <h3 style="color: #171d25; display: inline-block;">{{ info.name }}</h3>
      <div style="float: right">
        <Button type="default" icon="md-refresh" @click="init" style="margin-right: 10px" size="small">刷新</Button>
        <Button type="warning" @click="$refs.VolumeEdit.modifyOpenModal(info)" style="margin-right: 10px" size="small">编辑</Button>
        <VolumeActionMenu
          :status="info.status"
          :migration_status="info.migration_status"
          :replication_status="info.replication_status"
          :volume_id="info.id"
          :volume_name="info.name" v-on:callback="init" style="margin-right: 10px"></VolumeActionMenu>
      </div>
    </Card>
    <div class="main">
      <div>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <div>
              <Alert v-if="infoError" type="warning" show-icon>获取云硬盘详情数据失败</Alert>
              <div class="info-property" v-else style="margin-right: unset">
                <div class="resource-content-title">
                  <h4>云硬盘信息</h4>
                </div>
                <dl>
                  <dt>名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>ID</dt><dd>{{ info.id }}</dd>
                </dl>
                <dl>
                  <dt>状态</dt>
                  <Badge v-if="info.status" :status="volumeStatusTransfer(info.status).color" :text="volumeStatusTransfer(info.status).status"></Badge>
                </dl>
                <dl>
                  <dt>类型</dt>
                  <dd>{{ info.volume_type }}</dd>
                </dl>
                <dl>
                  <dt>大小</dt>
                  <dd>{{ info.size }} GiB</dd>
                </dl>
                <dl>
                  <dt>可启动</dt>
                  <dd>
                    <span v-if="info.bootable === 'true' || info.bootable === 'True'">是</span>
                    <span v-else>否</span>
                  </dd>
                </dl>
                <dl>
                  <dt>加密的</dt>
                  <dd>
                    <span v-if="info.encrypted">是</span>
                    <span v-else>否</span>
                  </dd>
                </dl>
                <dl>
                  <dt>挂载到</dt>
                  <dd>
                    <div v-for="(item, index) in info.attachments" :key="'attachments_' + index">
                      <p>
                        <a v-on:click="$router.push({ name: 'private_cloud_server_detail', params: { id: item.server_id } })">{{ resourceServerIdTransName(item.server_id) }}</a>
                        <span> 实例上的 {{ item.device }}</span>
                      </p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>创建时间</dt><dd v-if="info.created_at">{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl>
                  <dt>更新时间</dt><dd v-if="info.updated_at">{{ moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
              </div>
            </div>
            <div>
              <Row class="title" :style="{marginTop: '15px'}">
                <h4 :style="{float: 'left'}">快照</h4>
                <a v-on:click="$refs.SnapshotList.getSnapshotData()" style="line-height: 32px; padding-left: 10px">
                  <Icon type="md-refresh" size="18"/>
                </a>
              </Row>
              <Row>
                <SnapshotList ref="SnapshotList" :volume_id="$route.params.id" :show-refresh-btn="false"></SnapshotList>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import { detailPrivateCloudVolume } from '@/api/private-cloud/volume'
import { statusTransfer } from '@/view/private-cloud/storage/volume_status_transfer'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import VolumeActionMenu from './components/volume-action-menu'
import VolumeEdit from './components/volume-edit'
import SnapshotList from './snapshot'
import moment from 'moment'

export default {
  name: 'volume-detail',
  components: {
    VolumeActionMenu,
    VolumeEdit,
    SnapshotList
  },
  data () {
    return {
      info: {},
      infoError: false,
      status: {
        label: '',
        color: ''
      },
      moment: moment
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getInfo()
    },
    getInfo () {
      detailPrivateCloudVolume(this.$route.params.id).then(res => {
        this.infoError = false
        this.info = res.data.volume
      }).catch(res => {
        this.infoError = true
      })
    },
    volumeStatusTransfer (status) {
      return statusTransfer(status)
    },
    resourceServerIdTransName (id) {
      return resourceIdTransName('servers', id)
    }
  }
}
</script>

<style lang="less">
  @import '../base.less';
</style>
